module.exports = __webpack_public_path__ + "img/changelly.fb3c1d5b.png";